module.exports = __webpack_public_path__ + "static/media/reprise.a12ea869.jpg";